module.exports = __webpack_public_path__ + "img/img4.e571ec7b.jpg";